import Auth from './Auth';
import NotFound from './NotFound';

export default () => [...Auth, NotFound];
